import { request } from '../gonfalon';

export const getFullTable = (table: string, field: string) =>
  request({
    url: `/private/pricing-calculator/${table}?field=${field}`,
  }).toPromise();
